//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList as theaterAreaList } from "@/api/PMS/performancecenter/theaterArea";
import { fetchCreate, fetchUpdate, fetchDetail } from "@/api/PMS/performancecenter/theaterAreaPrice";
export default {
  props: ['keyValue', 'showDialog', 'theaterId', 'activityItemId'],
  data: function data() {
    return {
      rules: {
        areaId: [{
          required: true,
          message: '请选择区域名称',
          trigger: 'change'
        }],
        price: [{
          required: true,
          type: "number",
          message: '请输入价格',
          trigger: 'blur'
        }]
      },
      childData: {
        areaId: '',
        price: null
      },
      areaOption: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    getTheaterList: function getTheaterList() {
      var _this = this;

      theaterAreaList({
        theaterId: this.theaterId
      }).then(function (response) {
        _this.areaOption = response.data.data;
      });
    },
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });
      this.getTheaterList();

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;
        });
      } else {
        this.childData = {
          areaId: '',
          price: null
        };
      }
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this3.$set(_this3.childData, "activityItemId", _this3.activityItemId);

          if (_this3.keyValue > 0) {
            fetchUpdate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            fetchCreate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};